<template>
  <a-drawer
    :maskClosable="false"
    width="80%"
    title="详情"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
  >
    <a-tabs @change="callback" :activeKey="active" type="card">
      <a-tab-pane :key="1" tab="基本信息">
        <a-descriptions :column="2" bordered class="full-width-descriptions">
          <a-descriptions-item label="维修品名称">{{ form.prodName }}</a-descriptions-item>
          <a-descriptions-item label="分类名称">{{ form.categoryName }}</a-descriptions-item>
          <a-descriptions-item label="主图">
            <div v-viewer>
              <img
                :src="$url + form.pic"
                style="width: 80px; height: 80px"
                @error="(e) => (e.target.src = errorImage)"
              />
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="主图视频" v-if="form.video">
            <video :src="$url + form.video" controls style="width: 200px; height: 120px" />
          </a-descriptions-item>

          <a-descriptions-item label="原价">{{ form.oriPrice }}</a-descriptions-item>
          <a-descriptions-item label="现价">{{ form.price }}</a-descriptions-item>

          <a-descriptions-item label="销量">{{ form.soldNum }}</a-descriptions-item>
          <a-descriptions-item label="虚拟销量">{{ form.virtuallySoldNum }}</a-descriptions-item>

          <a-descriptions-item label="排序">{{ form.sort }}</a-descriptions-item>
          <a-descriptions-item label="状态">
            <a-tag :color="statusTag.color">{{ statusTag.text }}</a-tag>
          </a-descriptions-item>

          <a-descriptions-item label="上架时间">{{ form.putawayTime }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ form.createTime }}</a-descriptions-item>

          <a-descriptions-item label="简要描述" :span="1">{{ form.brief || '--' }}</a-descriptions-item>

          <a-descriptions-item label="备注" :span="1">{{ form.remark || '--' }}</a-descriptions-item>

          <a-descriptions-item label="维修品相册" :span="2" v-if="form.imgs">
            <div v-viewer>
              <img
                v-for="(url, i) in form.imgs.split(',')"
                :key="i"
                :src="$url + url"
                style="width: 80px; height: 80px; margin-right: 8px"
                @error="(e) => (e.target.src = errorImage)"
              />
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </a-tab-pane>
      <!-- v-if="hasPermission('system:jing:three')" -->
      <a-tab-pane :key="3" tab="规格列表信息" >
        <a-table :rowKey="(r, i) => r.id || i" :columns="skuColumns" :data-source="form.skus" :bordered="false">
          <template slot="isServiceFee" slot-scope="t">
            {{ t ? '上门服务' : '不上门服务' }}
          </template>
          <span slot="pic" slot-scope="t, r">
            <div v-viewer>
              <img :src="$url + r.pic" style="width: 80px; height: 80px" />
            </div>
          </span>
          <span slot="operation" slot-scope="t, r">
            <a-dropdown v-hasPermi="['upkeep:prod-sku-material-item:list', 'upkeep:prod-sku-material-item:add']">
              <a class="ant-dropdown-link" @click.prevent> <a-icon type="double-right" /> 更多 </a>
              <a-menu slot="overlay">
                <a-menu-item v-hasPermi="['upkeep:prod-sku-material-item:list']">
                  <a @click="$refs.materialPricingList.open(r, 1)"> <a-icon type="eye" /> 查看维修材料价 </a>
                </a-menu-item>
                <a-menu-item v-hasPermi="['2627d9a98c563c56cc5cbe56ac95d806b:0:b']">
                  <a @click="$refs.ServicePricingDrawer.open(r, 1)"> <a-icon type="eye" /> 查看维修服务费 </a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
      </a-tab-pane>
    </a-tabs>

    <materialPricing ref="materialPricingList" @close="onClose" :tenant-firm-id="124" :tenant-id="752" />
    <ServicePricingDrawer ref="ServicePricingDrawer" @close="onClose" :tenant-firm-id="124" :tenant-id="752" />
  </a-drawer>
</template>

<script>
import { getObj } from '@/api/repairModule/repairProducts'
import materialPricing from '../materialPricing/index'
import ServicePricingDrawer from './ServicePricingDrawer'
export default {
  name: 'Post',
  components: { materialPricing, ServicePricingDrawer },
  data() {
    return {
      visible: false,
      form: {},
      errorImage: require('@/assets/images/defaultImg.png'),
      active: 1,
      skuColumns: [
        { title: 'SKU名称', dataIndex: 'skuName', align: 'center', width: 150 },
        { title: '图片', dataIndex: 'pic', width: 120, align: 'center', scopedSlots: { customRender: 'pic' } },
        {
          title: '是否上门',
          dataIndex: 'isServiceFee',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'isServiceFee' },
        },
        { title: '原价', dataIndex: 'oriPrice', align: 'center', width: 100 },
        { title: '现价', dataIndex: 'price', align: 'center', width: 100 },
        { title: '最大维修价', dataIndex: 'maxPrice', align: 'center', width: 110 },
        { title: '参考价', dataIndex: 'referencePrice', align: 'center', width: 110 },
        { title: '排序', dataIndex: 'sort', align: 'center', width: 70 },
        { title: '状态', dataIndex: 'status', align: 'center', width: 70 },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
        },
      ],
    }
  },
  computed: {
    hasPermission() {
      return (p) => this.$store.state.user.userTentant.type === 0 || this.$store.state.user.permissions.includes(p)
    },
    statusTag() {
      const map = {
        '-1': { text: '删除', color: 'red' },
        0: { text: '商家下架', color: 'orange' },
        1: { text: '上架中', color: 'green' },
        2: { text: '违规下架', color: 'red' },
        3: { text: '平台审核', color: 'blue' },
      }
      // 兜底：如果后端返回了未知状态，显示“未知”+灰色
      return map[this.form.status] || { text: '未知', color: 'default' }
    },
  },
  methods: {
    init(e, index) {
      this.active = index
      this.$forceUpdate()
      getObj(e.id).then((res) => {
        this.form = res.data
        this.dataForm = e
      })
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
    callback(e) {
      this.active = e
    },
  },
}
</script>

<style lang="less" scoped>
.full-width-descriptions {
  width: 100%;
}
.ant-descriptions-item-label {
  width: 120px;
  text-align: right;
}
img {
  width: 80px;
  height: 80px;
}
</style>
